import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import SolicitudesGrid from './SolicitudesGrid'
import SolicitudesAbm from './SolicitudesAbm'
import SolicitudesDetalle from './SolicitudesDetalle'
import { FormattedMessage, injectIntl } from 'react-intl';

class Solicitudes extends Component {
	render() {
		return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
						<h3 className="content-header-title"><i className="icon-wrench ml-1 mr-1 align-middle"></i><FormattedMessage id="solicitudes.title" defaultMessage="Solicitudes" /></h3>
					</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={SolicitudesGrid} />
						<Route exact path={`${this.props.match.url}/add`} component={(props) => <SolicitudesAbm {...props} />} />
						<Route exact path={`${this.props.match.url}/:id(\\d+)`} component={SolicitudesDetalle} />
					</Switch>
				</div>
			</div>
		);
	}
}

export default injectIntl(Solicitudes);
